import { BiCalendarCheck } from "react-icons/all";
import { Box, MenuItem, useColorModeValue } from "@chakra-ui/react";
import { useHistory } from "react-router-dom";

import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";

import { Icon } from "components/Icon";
import { ChakraText } from "components/ChakraText";
import { useGetThemeColors } from "ChakraTheme";

interface IProps {
  closeMenu: () => void;
}

const ActualAppointmentsMenuItem = ({ closeMenu }: IProps) => {
  const colors = useGetThemeColors();
  const iconColor = useColorModeValue(colors.black, colors.white);
  const { friendlyUrl } = useGetFriendlyUrl();
  const history = useHistory();

  //id w Box z tego względu, że MenuItem nie przekazuje poprawnie id z propsów i cały czas pozostaje id defaultowy
  return (
    <Box id="logged-user-menu-actual-appointments-btn">
      <MenuItem
        icon={<Icon color={iconColor} w={5} h={5} icon={BiCalendarCheck} />}
        onClick={() => {
          history.push(
            `/e-rezerwacja/${friendlyUrl}/uzytkownik/aktualne-wizyty`
          );
          closeMenu();
        }}
      >
        <ChakraText>Aktualne wizyty</ChakraText>
      </MenuItem>
    </Box>
  );
};

export { ActualAppointmentsMenuItem };
